import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // ✅ MUST BE FIRST
import "./App.css"; // ✅ MUST BE AFTER

import MyRoutes from "./Routes/MyRoutes";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { MyContext } from "./Context/MyContext";
import Loader from "./Config/Loader";
import CookieConsentBanner from "./Components/CookieConsentBanner";

function App() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isPartnerRoute = location.pathname.startsWith("/partner");

  const noSpacingRoutes = ["/login", "/"];
  const removeSpacing =
    noSpacingRoutes.includes(location.pathname) ||
    isAdminRoute ||
    isPartnerRoute;

  const { loading } = useContext(MyContext);

  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        closeButton={true}
        icon={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        draggable={false}
        newestOnTop
        limit={1}
        transition={Slide}
        theme="colored"
      />

      {loading && <Loader />}

      <div className={removeSpacing ? "" : "app-content"}>
        <MyRoutes />
      </div>
      {!isAdminRoute && !isPartnerRoute && <CookieConsentBanner />}
    </div>
  );
}

export default App;